module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House38.5b504360.jpg";